export class EventWithPayload extends Event {
  payload: any;
}